import { compactI18n, parseI18n } from '@src/i18n';

export const TITLE_MAX_LENGTH = 100;
export const DESCRIPTION_MAX_LENGTH = 500;

// Form values of a test. Every language of `languages` starts blank, so that showing an empty language and undoing an
// edit in it leaves the form clean.
export const toFormValues = (test, languages = []) => {
    const blank = Object.fromEntries(languages.map(({ label }) => [label, '']));

    return {
        title: { ...blank, ...parseI18n(test.title) },
        description: { ...blank, ...parseI18n(test.description) },
        languageId: test.languageId ?? null,
        levelId: test.level?.id ?? null,
        pedagogical: Boolean(test.pedagogical),
        status: test.status ?? null,
    };
};

// Payload of PUT /tests/{reference}: the description is null when no language holds a text.
export const toPayload = (values) => {
    const description = compactI18n(values.description);

    return {
        title: JSON.stringify(compactI18n(values.title)),
        description: Object.keys(description).length > 0 ? JSON.stringify(description) : null,
        languageId: values.languageId,
        levelId: values.levelId,
        pedagogical: values.pedagogical,
        status: values.status,
    };
};

// Language codes whose title is empty, marked with a dot on their tab.
export const emptyLanguages = (titles = {}, languages = []) =>
    languages.map(({ label }) => label).filter((label) => !(titles[label] ?? '').trim());
